var _a;
const initBlockCoursesDropdown = () => {
    const items = document.querySelectorAll('.block-courses-list__item');
    if (!items.length)
        return;
    items.forEach((item, idx) => {
        const toggler = item.querySelector('#js--dropdown-toggler, [data-acc-toggle]');
        const panel = item.querySelector('#js--dropdown-panel, [data-acc-panel]');
        if (!toggler || !panel)
            return;
        if (toggler.dataset.bound === 'true')
            return;
        toggler.dataset.bound = 'true';
        if (!panel.id)
            panel.id = `course-panel-${Date.now()}-${idx}`;
        toggler.setAttribute('role', 'button');
        toggler.setAttribute('tabindex', '0');
        toggler.setAttribute('aria-controls', panel.id);
        toggler.setAttribute('aria-expanded', 'false');
        const toggle = () => {
            const isOpen = item.classList.contains('active');
            items.forEach((other) => {
                other.classList.remove('active');
                const otherToggler = other.querySelector('#js--dropdown-toggler, [data-acc-toggle]');
                if (otherToggler)
                    otherToggler.setAttribute('aria-expanded', 'false');
            });
            if (isOpen) {
                item.classList.remove('active');
                toggler.setAttribute('aria-expanded', 'false');
            }
            else {
                item.classList.add('active');
                toggler.setAttribute('aria-expanded', 'true');
            }
        };
        toggler.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle();
        });
        toggler.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
            }
        });
    });
};
const initBlockExample = () => {
    const blocks = document.querySelectorAll('.block-example');
    if (blocks)
        blocks.forEach((block) => block.classList.add('active'));
    initBlockCoursesDropdown();
};
document.addEventListener('DOMContentLoaded', initBlockExample, false);
if (window['acf']) {
    (_a = window['acf']) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBlockExample);
}
export {};
